module.exports = __webpack_public_path__ + "static/media/nenhum_dado.aba68723.png";